import React, { FunctionComponent, useState } from 'react'

import { generateUri } from '@commerce/utils/uri-util'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import Link from 'next/link'
import 'swiper/css'
import 'swiper/css/navigation'

interface ICustomSwiper {
  slidesPerView: number | 'auto' | undefined
  slidesPerView1: number | 'auto' | undefined
  slidesPerView2: number | 'auto' | undefined
  slidesPerView3: number | 'auto' | undefined
  spaceBetween: string | number | undefined
}

interface IProps {
  className: string
  images: IImage[]
  isOnlyMobile: boolean
  swiperProps: ICustomSwiper
  setIsImageLoaded: (payload: boolean) => void
}

export interface IImage {
  alt: string
  mobileUrl: string
  url: string
  title: string
  description: string
  link: string
}

const CustomSwiperPLPTopBanner: FunctionComponent<IProps> = ({
  images,
  className,
  setIsImageLoaded,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const totalSlides = images.length
  return (
    <>
      <div className={`swiper-container ${className}`}>
        {/* Previous button */}
        {/* {currentIndex > 0 && (
          <div
            className="swiper-prev-button"
            onClick={() => setCurrentIndex(currentIndex - 1)}
          />
        )} */}
        <div className="swiper-list">
          {images.map((img: IImage, idx: number) => {
            function bannerClick(img: IImage, idx: number): void {
              throw new Error('Function not implemented.')
            }

            return (
              <div
                className={`swiper-item ${
                  idx === currentIndex ? 'active-slide' : ''
                }`}
                key={idx}
              >
                <div className={`relative w-full max-h-[530px] px-0`}>
                  <Link legacyBehavior href={img?.link || '#'} passHref>
                    <a onClick={() => bannerClick(img, idx)} className="block">
                      <img
                        onLoad={() => {
                          setIsImageLoaded(true)
                        }}
                        src={
                          generateUri(
                            img?.mobileUrl || img?.url,
                            'h=713&q=50'
                          ) || IMG_PLACEHOLDER
                        }
                        alt="Collection Banner"
                        className="h-[475px]"
                        fetchPriority={idx === 0 ? 'high' : 'low'}
                      />
                    </a>
                  </Link>
                  <div className="absolute z-10 text-left bottom-3 left-4">
                    <h3 className="font-medium text-white text-14">
                      {img?.title}
                    </h3>
                    <p className="mb-2 font-normal text-left text-white text-10">
                      {img?.description}
                    </p>
                    {img?.title ? (
                      <>
                        <Link legacyBehavior href={img?.link} passHref>
                          <a
                            onClick={() => bannerClick(img, idx)}
                            className="font-medium text-left text-white underline text-12"
                          >
                            Shop now
                          </a>
                        </Link>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        {/* {currentIndex < totalSlides - 1 && (
          <div
            className="swiper-next-button"
            onClick={() => setCurrentIndex(currentIndex + 1)}
          />
        )} */}
      </div>
    </>
  )
}

export default CustomSwiperPLPTopBanner
